import { type Auth0Client, createAuth0Client } from "@auth0/auth0-spa-js";
import log from "loglevel";

import config from "@/config";

let clientPromise: Promise<Auth0Client> | null = null;

export function getAuth0Client(): Promise<Auth0Client> {
  if (!clientPromise) {
    if (!config.auth0Domain || !config.auth0ClientId) {
      throw new Error("Auth0 is not configured (VITE_AUTH0_DOMAIN / VITE_AUTH0_CLIENT_ID)");
    }
    clientPromise = createAuth0Client({
      domain: config.auth0Domain,
      clientId: config.auth0ClientId,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/end`,
      },
      cacheLocation: "localstorage",
      useRefreshTokens: true,
      // Fall back to iframe checkSession when refresh-token renewal fails (e.g. rotation edge cases).
      useRefreshTokensFallback: true,
    });
  }
  return clientPromise;
}

/**
 * Clear the local @auth0/auth0-spa-js (social) session without redirecting. openUrl: false makes
 * logout() wipe only the SPA SDK localStorage cache, leaving the auth0-js passwordless token intact.
 */
export async function clearSocialSpaSession(): Promise<void> {
  try {
    const client = await getAuth0Client();
    await client.logout({ openUrl: false });
  } catch (error) {
    log.error("Failed to clear social SPA session:", error);
  }
}
